/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Email_PlaceholderInputs */

const en_contact_form_email_placeholder = /** @type {(inputs: Contact_Form_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your@email.com`)
};

const lv_contact_form_email_placeholder = /** @type {(inputs: Contact_Form_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jusu@epasts.lv`)
};

/**
* | output |
* | --- |
* | "your@email.com" |
*
* @param {Contact_Form_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_form_email_placeholder = /** @type {((inputs?: Contact_Form_Email_PlaceholderInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Email_PlaceholderInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_form_email_placeholder(inputs)
	return en_contact_form_email_placeholder(inputs)
});